module.exports = __webpack_public_path__ + "static/media/GelangPengawasanDanPemantauanDiRumahHSO.3bc98726.jpg";